import React from "react";
import { ToastContainer } from "react-toastify";
import AddTestimonial from "../../components/Settings/Testimonial/AddTestimonial";

export const AddTestimonialPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddTestimonial />
        </div>
      </div>
    </div>
  );
};
